module.exports = __webpack_public_path__ + "static/media/bg-image9.21fb865c.jpg";